import React, { useState } from "react";

const RightMessage = ({ text, maxLength = 100 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => setIsExpanded(!isExpanded);

  if (!text) return null;

  const shouldTruncate = text.length > maxLength;
  const displayedText =
    isExpanded || !shouldTruncate ? text : text.slice(0, maxLength) + "...";
  return (
    <div className="flex items-center float-right chat-text-box__content">
      <div className="max-w-72 px-4 py-3 leading-relaxed text-white box bg-theme-1 text-opacity-80 bg-primary shadow rounded-md text-sm font-medium">
        {displayedText}
        {shouldTruncate && (
          <span
            onClick={toggleReadMore}
            className="ml-1 text-blue-400 cursor-pointer hover:underline"
          >
            {isExpanded ? "Read Less" : "Read More"}
          </span>
        )}
      </div>
    </div>
  );
};

export default RightMessage;
